import React from 'react';
import Button from '../../components/button/Button';
import styles from './Header.module.css';

const Header = () => {
  return (
    <div className={styles.container}>
      <div className={styles.headingContainer}>
        <h1 className={styles.mainText}>
          <span className={styles.highlight}>新青匯</span>
          累計組織<span className={styles.highlight}>逾千名</span>
          香港各界青年
          <br />
          前往內地各大城市考察， 促進兩地青年交流。
        </h1>
        <a href="#about">
          <Button text="了解更多"></Button>
        </a>
      </div>
      <div className={styles.rectContainer}>
        <div className={styles.rectangle}></div>
        <div className={styles.rectangle2}></div>
      </div>
    </div>
  );
};

export default Header;
